module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"detail":"details"},"ja":{"detail":"内訳"},"zh-hant":{"detail":"詳細"},"zh-hans":{"detail":"详细"}}')
  delete Component.options._Ctor
}
